import React from "react";
import { ChatLoadSkeleton, SkeletonLeftSide, SkeletonMessage, SkeletonRightSide, StackSkeleton } from "../chatStyled";

const ChatBodyLoad: React.FC<{ isVipPage?: boolean }> = ({ isVipPage }) => {
    return (
        <ChatLoadSkeleton $isVipPage={isVipPage}>
            <StackSkeleton spacing={1}>
                <SkeletonLeftSide>
                    <SkeletonMessage variant="rounded" />
                </SkeletonLeftSide>
                <SkeletonLeftSide>
                    <SkeletonMessage variant="rounded" />
                </SkeletonLeftSide>
                <SkeletonRightSide>
                    <SkeletonMessage variant="rounded" />
                </SkeletonRightSide>
                <SkeletonRightSide>
                    <SkeletonMessage variant="rounded" />
                </SkeletonRightSide>
                <SkeletonRightSide>
                    <SkeletonMessage variant="rounded" />
                </SkeletonRightSide>
            </StackSkeleton>
        </ChatLoadSkeleton>
    );
}

export default ChatBodyLoad;
